<template>
    <div class="table">
        <!-- <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>宿舍管理->寄宿生考勤统计</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.name" placeholder="姓名"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.identityCard" placeholder="身份证"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.className" placeholder="班级名称"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.roomNumber" placeholder="房间号"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-date-picker
                    v-model="form.workDate"
                    type="month"
                    placeholder="考勤日期"
                    style="width:120px;"
                    value-format="yyyy-MM">
                </el-date-picker>
            </div>
            &nbsp;
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            &nbsp;&nbsp;
            <el-button type="primary" icon="search" @click="exportExcel">导出Excel</el-button>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55"  :selectable="selectable"></el-table-column> -->
                <el-table-column type="index" label="序号" fixed width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="姓名"  fixed :show-overflow-tooltip="true" width="100"></el-table-column>
                <el-table-column prop="identityCard" label="身份证" fixed :show-overflow-tooltip="true" width="150"></el-table-column>
                <el-table-column prop="gradeName" label="年段名称" :show-overflow-tooltip="true" width="150"></el-table-column>
                <el-table-column prop="className" label="班级名称" :show-overflow-tooltip="true" width="150"></el-table-column>
                <el-table-column prop="roomNumber" label="房间号" :show-overflow-tooltip="true" width="150"></el-table-column>
                <el-table-column prop="workDates" label="考勤日期" :show-overflow-tooltip="true" width="110"></el-table-column>
                <el-table-column prop="normalCount" label="已归次数" :show-overflow-tooltip="true" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.normalCount !=''">
                            {{scope.row.normalCount}}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="notReturnCount" label="未归次数" :show-overflow-tooltip="true" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.notReturnCount !=''">
                            {{scope.row.notReturnCount}}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="lateReturnCount" label="晚归次数" :show-overflow-tooltip="true" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.lateReturnCount !=''">
                            {{scope.row.lateReturnCount}}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="longTimeNotReturnCount" label="长时未归次数" :show-overflow-tooltip="true" width="80"></el-table-column> -->
                <el-table-column prop="longTimeLateReturnCount" label="长时晚归次数" :show-overflow-tooltip="true" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.longTimeLateReturnCount !=''">
                            {{scope.row.longTimeLateReturnCount}}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="notOutCount" label="未出次数" :show-overflow-tooltip="true" width="80"></el-table-column> -->
                <!-- <el-table-column prop="longTimeNotOutCount" label="长时未出次数" :show-overflow-tooltip="true" width="80"></el-table-column> -->
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../common/http'; 

    export default {
        name:"boarderAttendanceCount",
        data(){
            return{
                loading:false,
                loadingText:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    deptId:"",
                    workDate:"",
                    name:"",
                    identityCard:"",
                    roomNumber:"",
                    className:""
                },
                data:[],
                depts:[]
            }
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";

                let url  = this.listBoarderAttendanceCountUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    workDate:(this.form.workDate==null?"":this.form.workDate),
                    name:this.form.name,
                    identityCard:this.form.identityCard,
                    className:this.form.className,
                    roomNumber:this.form.roomNumber,
                    deptId:this.form.deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.data;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            exportExcel(){
                let msg="导出学生考勤数据只支持导出1W条，超出会导出失败，请确认当前页面总条数！";
                this.$commonFn.showConfirm2(msg,this.exportData);
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.exportBoarderAttendanceCountUrl;
                let param = new URLSearchParams();
                param.append('workDate', (this.form.workDate==null?"":this.form.workDate));
                param.append('name', this.form.name);
                param.append('identityCard', this.form.identityCard);
                param.append('className', this.form.className);
                param.append('roomNumber', this.form.roomNumber);
                param.append('deptId', this.form.deptId);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '寄宿生考勤统计.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error); 
                    this.loading=false;
                });
           }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/hostel/boarderAttendanceCount.vue